import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useMutation, useQueryClient } from "react-query";
import { Modal, Button, Input } from "rsuite";
import apiClient from "../../libraries/ApiClient";
import { useContext } from "react";
import { ModelContext } from "../../contexts/ModelContext";

const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function Patient_ReportReferral_XmarkRegular({ rowId, code }) {
  const queryClint = useQueryClient();
  const [token, setToken] = useState("");
  const [reason, setReason] = useState("");
  const [name, setName] = useState("");
  const [Case, setCase] = useState("");
  const {
    setOpenAskSaveModel,
    changeData,
    openSecondModel,
    setOpenSecondModel,
    openSecondModelName,
    setOpenSecondModelName,
  } = useContext(ModelContext);

  const handleOpen = () => {
    console.log(changeData);
    setOpenSecondModelName("Patient_ReportReferral_XmarkRegular");
    setCase(code);
    if (changeData) {
      setOpenAskSaveModel(true);
    } else {
      setOpenSecondModel(true);
    }
  };

  const open = () => {
    return (
      openSecondModel &&
      openSecondModelName === "Patient_ReportReferral_XmarkRegular" &&
      Case == code      
    );
  };
  const handleClose = () => setOpenSecondModel(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    setName(JSON.parse(localStorage.getItem("auth"))?.Name);
  }, []);

  const sendCheckData = async ({ rowId, code, token, reason }) => {
    const data = {
      Data: {
        RowId: rowId,
        Code: code,
        Value: 0,
        Content: reason,
      },
    };

    const res = await apiClient.postAes(
      "api/referral/SetPatientStatus/Security",
      data
    );

    return res;
  };

  const {
    data: checkData,
    mutate,
    isLoading,
  } = useMutation(sendCheckData, {
    onSuccess() {
      alert("更新成功");
      //queryClint.invalidateQueries("getListData");
      window.location.reload(true);
    },
  });
  //console.log(checkData);
  return (
    <>
      <span style={{ padding: "5px" }} onClick={handleOpen}>
        <Container
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="2.5"
            stroke="#057AFF"
          />
          <path
            d="M15.7632 9.36623C16.0756 9.05388 16.0756 8.54662 15.7632 8.23427C15.4509 7.92191 14.9436 7.92191 14.6313 8.23427L12 10.868L9.36623 8.23676C9.05388 7.92441 8.54662 7.92441 8.23427 8.23676C7.92191 8.54912 7.92191 9.05638 8.23427 9.36873L10.868 12L8.23676 14.6338C7.92441 14.9461 7.92441 15.4534 8.23676 15.7657C8.54912 16.0781 9.05638 16.0781 9.36873 15.7657L12 13.132L14.6338 15.7632C14.9461 16.0756 15.4534 16.0756 15.7657 15.7632C16.0781 15.4509 16.0781 14.9436 15.7657 14.6313L13.132 12L15.7632 9.36623Z"
            fill="#057AFF"
          />
        </Container>
      </span>
      <Modal open={open()} onClose={handleClose} backdrop="static">
        <Modal.Header closeButton={false}>
          <Modal.Title>轉出醫院取消轉診</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>
            若要「取消轉診」請點選「確認」;若還在考慮請點選「取消返回」
          </div>
          <div style={{ fontSize: "14px" }}>已由{name}操作</div>
          <div style={{ fontSize: "14px" }}>
            回覆取消原因(非必填,但建議填寫)
          </div>
          <Input
            placeholder="請輸入原因"
            as="textarea"
            value={reason}
            onChange={setReason}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              mutate({ rowId, code, token, reason });
            }}
            appearance="primary"
            disabled={isLoading}
          >
            {isLoading ? "資料傳送中" : "確認"}
          </Button>
          <Button onClick={handleClose} disabled={isLoading}>
            取消返回
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Patient_ReportReferral_XmarkRegular;
